// src/utils/getVideoThumbnail.js
import detectSocialMediaPlatform from "./DetectSocialMediaPlatform";

const getVideoThumbnail = async (url) => {
  if (!url) {
    console.debug("getVideoThumbnail: No URL provided");
    return { thumbnailUrl: null, error: null };
  }

  const platform = detectSocialMediaPlatform(url);
  console.debug(`getVideoThumbnail: Detected platform - ${platform || "none"}`);

  try {
    switch (platform) {
      case "YouTube": {
        const urlObj = new URL(url);
        let videoId = urlObj.searchParams.get("v");
        if (!videoId && urlObj.pathname.includes("youtu.be")) {
          videoId = urlObj.pathname.split("/").pop()?.split("?")[0];
        }
        if (videoId) {
          console.debug(`getVideoThumbnail: YouTube video ID - ${videoId}`);
          return {
            thumbnailUrl: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
            error: null,
          };
        }
        console.debug("getVideoThumbnail: Invalid YouTube URL");
        return { thumbnailUrl: null, error: "Invalid YouTube URL" };
      }
      case "Vimeo": {
        const videoId = url.match(/vimeo\.com\/(\d+)/)?.[1];
        if (videoId) {
          console.debug(`getVideoThumbnail: Vimeo video ID - ${videoId}`);
          try {
            const response = await fetch(
              `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`
            );
            if (!response.ok) {
              console.debug(
                `getVideoThumbnail: Vimeo oEmbed error - ${response.status}`
              );
              return {
                thumbnailUrl: null,
                error: `Vimeo API error: ${response.statusText}`,
              };
            }
            const data = await response.json();
            if (data.thumbnail_url) {
              console.debug(
                `getVideoThumbnail: Vimeo thumbnail URL - ${data.thumbnail_url}`
              );
              return { thumbnailUrl: data.thumbnail_url, error: null };
            }
            console.debug("getVideoThumbnail: No Vimeo thumbnail available");
            return {
              thumbnailUrl: null,
              error: "No thumbnail available for Vimeo video",
            };
          } catch (e) {
            console.error("getVideoThumbnail: Vimeo fetch error", e);
            return {
              thumbnailUrl: null,
              error: "Failed to fetch Vimeo thumbnail",
            };
          }
        }
        console.debug("getVideoThumbnail: Invalid Vimeo URL");
        return { thumbnailUrl: null, error: "Invalid Vimeo URL" };
      }
      default:
        console.debug(
          `getVideoThumbnail: Unsupported platform - ${platform || "none"}`
        );
        return {
          thumbnailUrl: null,
          error: `Thumbnails not supported for ${platform || "this platform"}`,
        };
    }
  } catch (e) {
    console.error("getVideoThumbnail: URL parsing error", e);
    return { thumbnailUrl: null, error: "Invalid URL format" };
  }
};

export default getVideoThumbnail;
